import { DevotionalCoverImageLayer, DevotionalCoverImageTextLayer, EDevotionalCoverImageLayerType } from "grow.client";

export const isCoverImageTextLayer = (layer: DevotionalCoverImageLayer): layer is DevotionalCoverImageTextLayer => {
    return layer.type === EDevotionalCoverImageLayerType.Text;
}